/* The waiting-list form on /welcome#join. Posts one row to public.waitlist
   (supabase/migrations/0005_waitlist.sql): the public may INSERT only, and may not read the row back,
   so the insert asks for no representation. A second sign-up with the same email hits the unique
   index (409 / 23505) and is shown as "You're already on the list". */
/* supabase-js is loaded only when someone actually submits, so the landing page stays small */
var supa = null;
function loadSupa(){ return supa ? Promise.resolve(supa) : import("./supa.js").then(function(m){ supa = m; return m; }); }
function isOffline(err, status){ return supa ? supa.isOffline(err, status) : navigator.onLine === false || /fetch|network|import/i.test(String(err && err.message || err)); }

var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
var KINDS = ["trades", "office", "shop", "property", "other"];
var SIZES = ["Just me", "2–5", "6–20", "21+"];

function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]; }); }

export function initWaitlist(form, done){
  var client = null;
  var $ = function(id){ return document.getElementById(id); };
  var name = $("wl-name"), email = $("wl-email"), kind = $("wl-kind"), team = $("wl-team"), use = $("wl-use"),
      hp = $("wl-website"), status = $("wl-status"), btn = $("wl-submit"), count = $("wl-use-count");
  var touched = {};

  var rules = {
    name: function(){ var v = name.value.trim(); return !v ? "Please tell us your name." : v.length > 120 ? "That's a bit long — 120 characters at most." : ""; },
    email: function(){ var v = email.value.trim(); return !v ? "We need an email to invite you." : !EMAIL_RE.test(v) || v.length > 254 ? "That doesn't look like an email address." : ""; },
    kind: function(){ return KINDS.indexOf(kind.value) < 0 ? "Choose the closest match — “Something else” is fine." : ""; }
  };
  var inputs = {name: name, email: email, kind: kind};
  function check(key){
    var msg = rules[key](), el = inputs[key], err = $(el.id + "-err");
    err.textContent = msg;
    if(msg) el.setAttribute("aria-invalid", "true"); else el.removeAttribute("aria-invalid");
    return !msg;
  }
  Object.keys(inputs).forEach(function(k){
    var el = inputs[k];
    el.addEventListener("blur", function(){ if(el.value.trim() || touched[k]){ touched[k] = true; check(k); } });
    el.addEventListener(el.tagName === "SELECT" ? "change" : "input", function(){ if(touched[k] || el.getAttribute("aria-invalid")) check(k); });
  });
  use.addEventListener("input", function(){ count.textContent = use.value.length + " / 1000"; });

  function showStatus(kindCls, title, text){
    status.innerHTML = title ? '<div class="notice ' + kindCls + '"><b>' + esc(title) + '</b><span>' + esc(text) + '</span></div>' : "";
  }
  function busy(on){
    btn.disabled = on;
    btn.setAttribute("aria-busy", on ? "true" : "false");
    btn.innerHTML = on ? '<span class="spinner" aria-hidden="true"></span> Sending…' : "Join the waiting list";
  }
  function finish(first, already, addr){
    form.hidden = true;
    done.hidden = false;
    var head = done.parentNode.querySelector(".ic-head h3"); if(head) head.textContent = already ? "Already on the list" : "All done";
    done.innerHTML =
      '<span class="tick" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span>' +
      (already
        ? '<h3>You’re already on the list' + (first ? ", " + esc(first) : "") + '.</h3><p>No need to sign up again. We’ll email you when there’s a place.</p>'
        : '<h3>Thanks, ' + esc(first || "and welcome") + ' — you’re on the list.</h3><p>We’ll email you' + (addr ? ' at <b>' + esc(addr) + '</b>' : "") + ' when there’s a place.</p>') +
      '<p><a href="/help">Read how Tabwheel works</a> while you wait.</p>';
    done.focus();
  }

  form.addEventListener("submit", function(e){
    e.preventDefault();
    if(btn.disabled) return;
    touched = {name: true, email: true, kind: true};
    var ok = ["name", "email", "kind"].map(check).every(Boolean);
    if(!ok){
      showStatus("", "");
      var bad = form.querySelector('[aria-invalid="true"]'); if(bad) bad.focus();
      return;
    }
    var first = name.value.trim().split(/\s+/)[0];
    /* a bot filled the hidden field: say thanks, send nothing */
    if(hp.value){ finish(first, false, ""); return; }
    if(navigator.onLine === false){
      showStatus("bad", "You seem to be offline.", "Check your connection and try again. Nothing was sent.");
      return;
    }
    var row = {
      name: name.value.trim().slice(0, 120),
      email: email.value.trim().slice(0, 254),
      business_kind: kind.value,
      team_size: SIZES.indexOf(team.value) >= 0 ? team.value : null,
      use_for: use.value.trim().slice(0, 1000) || null
    };
    showStatus("", "");
    busy(true);
    loadSupa().then(function(m){
      client = client || m.anonClient();
      if(!client){
        busy(false);
        showStatus("bad", "The waiting list isn’t connected yet.", "Please try again later.");
        return;
      }
      return client.from("waitlist").insert(row).then(onResult);
    }).catch(onFail);
    function onResult(res){
      busy(false);
      var err = res.error;
      if(!err){ finish(first, false, row.email); return; }
      if(err.code === "23505" || res.status === 409){ finish(first, true, row.email); return; }
      if(isOffline(err, res.status)){
        showStatus("bad", "We couldn’t reach the server.", "Check your connection and try again. Nothing was sent.");
        return;
      }
      if(err.code === "23514"){
        showStatus("bad", "Something in the form wasn’t accepted.", "Please check your details and try again.");
        return;
      }
      showStatus("bad", "Sorry, that didn’t go through.", "Something went wrong on our side. Please try again in a minute.");
    }
    function onFail(err){
      busy(false);
      if(isOffline(err, 0)) showStatus("bad", "We couldn’t reach the server.", "Check your connection and try again. Nothing was sent.");
      else showStatus("bad", "Sorry, that didn’t go through.", "Something went wrong on our side. Please try again in a minute.");
    }
  });
}
